import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Router } from "./Router";
import { UserProvider } from "./UserContext";
import { CookiesProvider } from "react-cookie";


const App: React.FC = () => (

  <UserProvider>
    <CookiesProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Router />} />
        </Routes>
      </BrowserRouter>
    </CookiesProvider>
  </UserProvider>
)
export default App;
